import { API_URL } from 'src/constants';
import { fetch } from '../fetchWrapper/fetch';
import { GetBrandVenuesResponse } from './types';

export const getBrandVenues = async (brandId: string): Promise<GetBrandVenuesResponse> => {
  const uri = `${API_URL}/admin/brands/${brandId}/venues`;

  const response = await fetch(uri, {
    headers: {
      'brand-id': brandId,
    },
  });
  if (!response.ok) {
    throw new Error('Could not fetch venues');
  }
  return response.json();
};
